import React from 'react';

const appVersion = import.meta.env.VITE_APP_VERSION ?? '';
const environment = import.meta.env.VITE_APP_ENVIRONMENT ?? '';

const StatusBar: React.FC = () => {
  return (
    <div
      className="fixed bottom-0 left-0 right-0 z-40 flex h-7 items-center gap-6 border-t border-secondary/30 bg-primary px-4 text-xs font-medium text-primary-foreground shadow"
      aria-label="Application status"
    >
      <span>{appVersion}</span>
      <span>{environment}</span>
    </div>
  );
};

export default StatusBar;
